export const SEARCH_TYPE = {
    LOCATION: "location",
    DEVICE: "device",
    OEM_DEVICE: "oem-device",
    USER: "user",
}
